import { useEffect } from "react";

/**
 * Publishes the page scroller's vertical scrollbar width as the
 * `--app-scrollbar-width` CSS variable on <html>.
 *
 * The floating board-controls bar is `position: fixed` (relative to the
 * viewport), while board content scrolls inside `.app-shell--page-scroll`. When
 * that scroller shows a classic scrollbar, anything aligned to the viewport
 * would overhang the scrolled content by the scrollbar width. Exposing the width
 * lets CSS pull the docked bar's content back in to line up with the table.
 * The value is 0 when scrollbars are overlay (e.g. default macOS) or absent.
 */
export function useScrollbarWidthVar(): void {
  useEffect(() => {
    const update = () => {
      const scroller = document.querySelector<HTMLElement>(".app-shell--page-scroll");
      const width = scroller ? scroller.offsetWidth - scroller.clientWidth : 0;
      document.documentElement.style.setProperty("--app-scrollbar-width", `${width}px`);
    };
    update();
    window.addEventListener("resize", update);
    // Scroll can add/remove the scrollbar as content height crosses the viewport.
    window.addEventListener("scroll", update, { passive: true, capture: true });
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, { capture: true } as EventListenerOptions);
    };
  }, []);
}
